<template>
  <div class="main">
    <van-swipe height="227" @change="onChange">
      <van-swipe-item v-for="(img, index) of imgs" :key="index">
        <!-- <img :src="img"> -->
        <van-image
          class="img"
          fit="cover"
          :src="img || require('@/imgs/place.png')"
        />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{ imgs.length }}</div>
      </template>
    </van-swipe>
    <div class="title">
      <h1>
        {{ info.title }}
      </h1>
      <div class="des">
        {{ info.acreage || '面议' }}㎡ <span>{{ info.rent || '面议' }}</span>
        <p>元/月</p>
      </div>
      <div v-if="info.publishStatus === '2'" class="up">置顶</div>
    </div>
    <div class="info">
      <h1>商铺信息</h1>
      <div>
        <img src="@/imgs/details_region.png">
        <span>商铺地址</span>
        <p>{{ info.address || '暂无' }}</p>
      </div>
      <div>
        <img src="@/imgs/details_industry.png">
        <span>商铺行业</span>
        <p>{{ info.tradeName || '暂无' }}</p>
      </div>
      <div>
        <img src="@/imgs/details_describe.png">
        <span>商铺描述</span>
        <p>
          {{ info.description || '暂无' }}
        </p>
      </div>
    </div>
    <div class="footer">
      <div class="user">
        <img src="@/imgs/contacts.png">
        <p>{{ info.contact || '匿名用户' }}</p>
      </div>
      <div class="phone">
        {{ info.phone ? handlePhone(info.phone, true) : '' }}
      </div>
      <div class="btn" @click="getTell(info.phone)">
        <img src="@/imgs/home_call.png">
        <p>电话联系</p>
      </div>
    </div>
  </div>
</template>

<script>
import { transferDetail } from '@/api/api'
import { handlePhone } from '@/utils/util'
export default {
  name: 'StoreInfo',
  data() {
    return {
      current: 0,
      imgs: [],
      info: {}
    }
  },
  created() {
  },
  mounted() {
    this.transferDetail(this.$route.query.id)
  },
  methods: {
    handlePhone(phone, hide) {
      return handlePhone(phone, hide)
    },
    onChange(index) {
      this.current = index
    },
    getTell(phone) {
      const a = document.createElement('a')
      a.href = `tel:${phone}`
      a.style.display = 'none'
      a.click()
    },
    async transferDetail(publishId) {
      const res = await transferDetail({ publishId })
      this.info = res.data
      this.imgs = res.data.imgs.split(',')
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding-bottom: 130px;
  .img {
    width: 100%;
    height: 100%;
  }
  .custom-indicator {
    position: absolute;
    bottom: 20px;
    left: calc((100% - 68px) / 2);
    width: 68px;
    height: 24px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.3;
    border-radius: 12px;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    font-family: Arial;
    font-weight: 400;
    letter-spacing: 3px;
    color: rgba(255, 255, 255, 1);
  }
  .title {
    width: 750px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 0px 0px rgba(230, 230, 230, 1);
    padding: 29px 25px 45px 25px;
    position: relative;
    display: flex;
    flex-direction: column;
    .up {
      position: absolute;
      right: 0;
      bottom: 37px;
      width: 75px;
      height: 36px;
      background: rgba(253, 106, 66, 1);
      border-radius: 0px 12px 0px 12px;
      line-height: 36px;
      text-align: center;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
    h1 {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
    }
    .des {
      margin-top: 38px;
      display: flex;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      span {
        margin: 0 10px 0 30px;
        line-height: 32px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(248, 66, 66, 1);
      }
      p {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(248, 66, 66, 1);
      }
    }
  }
  .info {
    margin-top: 30px;
    width: 750px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 0px 0px rgba(230, 230, 230, 1),
      0px 1px 0px 0px rgba(229, 229, 229, 1);
    padding: 30px;
    h1 {
      font-size: 32px;
      line-height: 32px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
    }
    div {
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      // align-items: center;
      img {
        margin-top: 3px;
        height: 100%;
        margin-right: 9px;
        width: 26px;
      }
      span {
        padding-right: 60px;
        font-size: 28px;
        line-height: 34px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
      }
      p {
        flex: 1;
        font-size: 28px;
        line-height: 34px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 100px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 0px 0px rgba(229, 229, 229, 1);
    display: flex;
    align-items: center;
    padding: 0 30px 0 45px;
    .user {
      flex: 1;
      display: flex;
      img {
        margin-right: 10px;
        width: 40px;
        height: 40px;
      }
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(253, 106, 66, 1);
      }
    }
    .phone {
      margin-right: 30px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
    }
    .btn {
      display: flex;
      width: 187px;
      height: 48px;
      background: rgba(255, 91, 59, 1);
      border-radius: 8px;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 13px;
        width: 26px;
        height: 26px;
      }
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
      }
    }
  }
}
</style>
